import { render, staticRenderFns } from "./resultPwd.vue?vue&type=template&id=5822d73c&scoped=true&"
import script from "./resultPwd.vue?vue&type=script&lang=ts&"
export * from "./resultPwd.vue?vue&type=script&lang=ts&"
import style0 from "./resultPwd.vue?vue&type=style&index=0&id=5822d73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5822d73c",
  null
  
)

export default component.exports